import { ExportButton } from '@/common/buttons/ExportButton';
import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const PerspectiveTrxViewer = () => {
  const { navState } = useNavState();
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const gridRef = useRef();

  const [fieldDefs, setFieldDefs] = useState();
  const [exportReq, setExportReq] = useState();

  const pluginCode = navState.pluginCode;

  useEffect(() => {
    const reqParam = {
      ...navState.viewerReqParam,
      entity: navState.entity,
      viewerPluginCode: pluginCode,
      operation: 'FIELD_DEFS',
    };
    rsrc.data(module, 'VIEWER_DATA_PLUGIN', reqParam, navState.entity).then((fieldDefs) => {
      setFieldDefs(fieldDefs);
    });
  }, []);

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);

        const reqParam = {
          ...navState.viewerReqParam,
          entity: navState.entity,
          viewerPluginCode: pluginCode,
          operation: 'ROWS',
          expr,
          rowsReq: {
            startRow: params.startRow,
            endRow: params.endRow,
            expr,
            sortModel: params.sortModel,
          },
        };

        buildAndSetExportReq(reqParam, pluginCode);

        rsrc.data(module, 'VIEWER_DATA_PLUGIN', reqParam, navState.entity).then((res) => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        });

        // Count and totals depend only on the filter, not the scrolled page, so fetch them once
        // per filter (first block) instead of on every infinite-scroll block.
        if (params.startRow === 0) {
          const summaryReqParam = {
            ...navState.viewerReqParam,
            entity: navState.entity,
            viewerPluginCode: pluginCode,
            operation: 'AGGREGATES',
            rowsReq: { expr },
          };
          rsrc.data(module, 'VIEWER_DATA_PLUGIN', summaryReqParam, navState.entity).then((summary) => {
            gridRef.current.setRowCount(summary.count);
            gridRef.current.setTotalsRow(summary.totals);
          });
        }
      },
    };

    gridRef.current.setDataSource(dataSource);
  };

  const buildAndSetExportReq = (reqParam, plugin) => {
    const exportReq = {
      timeZoneName: DateUtils.timeZoneName(),
      name: navState.title + ' Export',
      module,
      entity: navState.entity,
      uiType: 'VIEWER',
      viewerPluginCode: plugin,
      viewerReqParam: reqParam,
      // The fieldDefs declare the grid's column order so the CSV matches the UI
      fieldDefs,
    };

    setExportReq(exportReq);
  };

  return (
    fieldDefs && (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Title icon={far.faListUl} title={navState.title} />

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ExportButton exportReq={exportReq} />
          </Box>
        </Box>
        <Grid ref={gridRef} gridOptions={{ fieldDefs }} events={{ onGridReady }} />
      </>
    )
  );
};
